import React, { useEffect, useMemo, useRef } from "react";
import { IoClose, IoSearch } from "react-icons/io5";
import { Input } from "../../elements";
import styles from "./autocomplete-search.module.css";
import { useAutocomplete } from "./hooks";

export function AutocompleteSearch() {
  const {
    inputValue,
    setInputValue,
    label,
    variant,
    setIsOpen,
    selectedItem,
    onChange,
    close,
    isOpen,
    dataQA,
    dataQaExtra,
    size,
  } = useAutocomplete();
  const inputRef = useRef<HTMLInputElement>(null);

  function handleFocus() {
    setIsOpen(true);
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setInputValue(e.target.value);
  }

  function handleClear() {
    close();

    if (!selectedItem) {
      inputRef.current?.focus();
    }

    setInputValue("");
    if (onChange) {
      onChange(null);
    }
  }

  const displayCloseButton = useMemo(() => {
    return inputValue !== "" || selectedItem;
  }, [inputValue, selectedItem]);

  useEffect(() => {
    if (isOpen && variant === "mobile") {
      inputRef.current?.focus();
    }
  }, [isOpen, variant]);

  return (
    <div className={styles.Header} data-variant={variant}>
      <Input
        onRightIconClick={handleClear}
        onChange={handleChange}
        onFocus={handleFocus}
        value={inputValue}
        ref={inputRef}
        label={label}
        dataQA={dataQA}
        dataQaExtra={dataQaExtra}
        size={size ?? "medium"}
        rightIcon={
          displayCloseButton ? (
            <IoClose size={20} color="#2E2D37" />
          ) : (
            <IoSearch size={20} color="#6A6977" />
          )
        }
      />

      {variant === "mobile" && (
        <button type="button" className={styles.Button} onClick={handleClear}>
          Cancelar
        </button>
      )}
    </div>
  );
}
